<template>
    <Component :is="as">
        <slot />
    </Component>
</template>

<script lang="ts" setup>

import {fieldsDisabledKey} from "~/utils/fieldManagement"

const {as = 'div', disabled = false} = defineProps<{
    as?: String,
    disabled?: Boolean,
}>()

provide(fieldsDisabledKey, computed(() => disabled))

</script>

<style scoped>

</style>